const MilestoneRoadmapDocumentsTestIdsScope = {
  MILESTONE_ROADMAP_DOCUMENTS: 'milestone-roadmap-documents',
};

export const MilestoneRoadmapDocumentsTestIds = {
  TOGGLE: `${MilestoneRoadmapDocumentsTestIdsScope.MILESTONE_ROADMAP_DOCUMENTS}.toggle`,
  SHOW_ALL: `${MilestoneRoadmapDocumentsTestIdsScope.MILESTONE_ROADMAP_DOCUMENTS}.show-all-button`,
  ROW: `${MilestoneRoadmapDocumentsTestIdsScope.MILESTONE_ROADMAP_DOCUMENTS}.row`,
  ROW_DOWNLOAD: `${MilestoneRoadmapDocumentsTestIdsScope.MILESTONE_ROADMAP_DOCUMENTS}.row-download-button`,
  ROW_OPEN: `${MilestoneRoadmapDocumentsTestIdsScope.MILESTONE_ROADMAP_DOCUMENTS}.row-open-button`,
};
